import type { StudioContentTableActions } from '../../actions/studio/content-table';
import { HYDRATE_STATE } from '../../store/consts';

type ColumnData = Record<
    string,
    Array<{
        name: string;
        isHidden: boolean;
    }>
>;

export type ColumnsType = 'cms-panel' | 'use-existing-modal';

export interface State {
    columns: {
        'cms-panel'?: ColumnData;
        'use-existing-modal'?: ColumnData;
    } | null;
}

const getDefaultState = (): State => ({
    columns: {
        'cms-panel': undefined,
        'use-existing-modal': undefined
    }
});

const contentTableReducer = (state = getDefaultState(), action: StudioContentTableActions | null): State => {
    switch (action?.type) {
        case 'STUDIO_SET_CONTENT_TABLE_COLUMN': {
            const contentTypeColumns = [...(state.columns?.[action.data.type]?.[action.data.contentType] ?? [])];
            const index = contentTypeColumns.findIndex((column) => column.name === action.data.name);
            if (index > -1) {
                contentTypeColumns[index] = {
                    name: action.data.name,
                    isHidden: action.data.isHidden
                };
            } else {
                contentTypeColumns.push({
                    name: action.data.name,
                    isHidden: action.data.isHidden
                });
            }
            const columns: ColumnData = {
                ...(state.columns?.[action.data.type] ?? {}),
                [action.data.contentType]: contentTypeColumns
            };
            return {
                ...state,
                columns: {
                    ...state.columns,
                    [action.data.type]: columns
                }
            };
        }

        case HYDRATE_STATE: {
            return {
                ...getDefaultState(),
                ...(action?.data.studio?.contentTable ?? {})
            };
        }

        default: {
            return state;
        }
    }
};

export default contentTableReducer;

export const localStorePaths = ['contentTable.columns'];
